<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<ol class="breadcrumb {{ customClass }}">
    @for (item of breadcrumbs; track item.id; let isActive = $last) {
        <li class="breadcrumb-item">
            @if (isActive) {
                {{ item.name }}
            } @else {
                <a (click)="changeCurrentState(item)">
                    {{ item.name }}
                </a>
            }
        </li>
    }
</ol>
